// removed by extract-text-webpack-plugin
module.exports = {"menuItem":"_1JAq1NIWI6byele2","thin":"_1yjr8TLlTzo5K5A-"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Menu/MenuItem.pcss
// module id = 474
// module chunks = 1